///////COMPONENTS///////
import { put, select, takeLatest } from 'redux-saga/effects'
import ActionsTypes from '../../constants/ActionsTypes'
import { globalLoadingActionCreators, errorManagerActionCreators, salesHistoryByCodesActionCreators, toastSuccessActionCreators } from '../actions'
import * as R from '../../constants/Endpoint'
import { API_TOKEN } from '../../config/AxiosConfig'
import { selectIdsUser } from '../selectors/user'

const getHistoCode = function* ({ payload }) {
	const bodyMsg = payload.filters
	const user = yield select(selectIdsUser)
	const apiCall = R.GET_HISTO_CODE(payload.queryParams)

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, bodyMsg)
		yield put(salesHistoryByCodesActionCreators.getHistoCodeSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(salesHistoryByCodesActionCreators.getHistoCodeFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const postDisplayTicket = function* ({ payload }) {
	const kiosk = payload.kiosksInLocalScope
	const id = payload.salesOrderId
	const user = yield select(selectIdsUser)
	const apiCall = R.POST_DISPLAY_TICKET(id)

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, kiosk)
		yield put(salesHistoryByCodesActionCreators.postDisplayTicketSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(salesHistoryByCodesActionCreators.postDisplayTicketFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const postReviewTicket = function* ({ payload }) {
	const kiosk = payload.kiosksInLocalScope
	const id = payload.salesOrderId
	const user = yield select(selectIdsUser)
	const apiCall = R.POST_REVIEW_TICKET(id)

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, kiosk)
		yield put(salesHistoryByCodesActionCreators.postReviewTicketSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(salesHistoryByCodesActionCreators.postReviewTicketFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const postSmsTicket = function* ({ payload }) {
	const kiosk = payload.kiosksInLocalScope
	const id = payload.salesOrderId
	const user = yield select(selectIdsUser)
	const apiCall = R.POST_SMS_TICKET(id)
	const MsgParams = 'toast__codesHistory__admin_resendCode'

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, kiosk)
		yield put(salesHistoryByCodesActionCreators.postSmsTicketSuccess(data.data))
		yield put(toastSuccessActionCreators.hydrateToast(MsgParams))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(salesHistoryByCodesActionCreators.postSmsTicketFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}
const postDeleteSaleCode = function* ({ payload }) {
	const kiosk = payload.kiosksInLocalScope
	const id = payload.salesOrderId
	const user = yield select(selectIdsUser)
	const apiCall = R.POST_DELETE_SALE_CODE(id)
	const MsgParams = 'toast__codesHistory__admin_deleteCode'

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, kiosk)
		yield put(salesHistoryByCodesActionCreators.postDeleteSaleCodeSuccess(data.data))
		yield put(toastSuccessActionCreators.hydrateToast(MsgParams))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(salesHistoryByCodesActionCreators.postDeleteSaleCodeFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}
const postCancelSaleCode = function* ({ payload }) {
	const kiosk = payload.kiosksInLocalScope
	const id = payload.salesOrderId
	const user = yield select(selectIdsUser)
	const apiCall = R.POST_CANCEL_SALE_CODE(id)
	const MsgParams = 'toast__codesHistory__admin_cancelCode'

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, kiosk)
		yield put(salesHistoryByCodesActionCreators.postCancelSaleCodeSuccess(data.data))
		yield put(toastSuccessActionCreators.hydrateToast(MsgParams))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(salesHistoryByCodesActionCreators.postCancelSaleCodeFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const postRenewCode = function* ({ payload }) {
	const kiosk = payload.kiosksInLocalScope
	const id = payload.salesOrderId
	const user = yield select(selectIdsUser)
	const apiCall = R.POST_RENEW_CODE(id)
	const MsgParams = 'toast__codesHistory__admin_renewCode'

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, kiosk)
		yield put(salesHistoryByCodesActionCreators.postRenewCodeSuccess(data.data))
		yield put(toastSuccessActionCreators.hydrateToast(MsgParams))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(salesHistoryByCodesActionCreators.postRenewCodeFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const sagas = function* () {
	yield takeLatest(ActionsTypes.GET_HISTO_CODE, getHistoCode)
	yield takeLatest(ActionsTypes.POST_DISPLAY_TICKET, postDisplayTicket)
	yield takeLatest(ActionsTypes.POST_REVIEW_TICKET, postReviewTicket)
	yield takeLatest(ActionsTypes.POST_SMS_TICKET, postSmsTicket)
	yield takeLatest(ActionsTypes.POST_DELETE_SALE_CODE, postDeleteSaleCode)
	yield takeLatest(ActionsTypes.POST_CANCEL_SALE_CODE, postCancelSaleCode)
	yield takeLatest(ActionsTypes.POST_RENEW_CODE, postRenewCode)
}

export default sagas
